// extracted by css-extract-rspack-plugin
export default {"fieldLabel":"fieldLabel-Bru5YF","infoButton":"infoButton-ZaSGSD"};